import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { get, api } from '../../lib/api';

export const useGetEditBoardSettings = () => {
  const { data = { demo: {} } } = useQuery(['editDemo'], () =>
    get(`/api/client_admin/board_settings`),
  );

  const { uuid, ...boardSettings } = useMemo(
    () =>
      data.demo.email
        ? { ...data.demo, email: data.demo.email.replace(/@.+/, '') }
        : data.demo,
    [data],
  );

  return { uuid, boardSettings };
};

export const useGetTimezones = () => {
  const { data = [] } = useQuery(['getTimeZones'], () =>
    get('/api/client_admin/time_zones'),
  );

  return data.map(timezone => ({ value: timezone, label: timezone }));
};

export const updateBoardSettings = ({ demo, id }) => {
  return api({
    method: 'patch',
    headers: { 'Content-Type': 'multipart/form-data' },
    url: `/api/client_admin/board_settings/${id}`,
    data: demo,
  });
};

export const useGetPopulationSegments = () =>
  useQuery(['populationSegments'], () =>
    get('/api/client_admin/population_segments'),
  );

export const deleteSegment = ({ segmentId }) => {
  return api({
    method: 'delete',
    url: `/api/client_admin/population_segments/${segmentId}`,
  });
};

export const createSegment = ({ segmentName }) => {
  return api({
    method: 'post',
    url: '/api/client_admin/population_segments',
    data: { population_segment: { name: segmentName } },
  });
};

export const updateInviteSpouse = ({ subject, body }) => {
  return api.put(`/api/client_admin/manage_invite_spouse`, {
    demo: {
      dependent_board_enabled: true,
      dependent_board_email_subject: subject,
      dependent_board_email_body: body,
    },
  });
};
